export enum VIPJobStatus {
  PENDING = 'VIPJobStatus:PENDING',
  IN_PROGRESS = 'VIPJobStatus:IN_PROGRESS',
  FAILED = 'VIPJobStatus:FAILED'
}
